import React, { useState } from "react";
import { ChevronDown, ChevronUp, ListChecks } from "lucide-react";

const STEPS = [
  { t: "Infomaniak Manager öffnen", d: "manager.infomaniak.com → einloggen → links «Public Cloud» (oder «Swiss Backup») → «Object Storage»." },
  { t: "Bucket erstellen", d: "«Bucket erstellen» → Name z.B. «buchhaltung-prod» (nur Kleinbuchstaben, Ziffern, Bindestrich) → Standort Schweiz (pub1) → Sichtbarkeit «Privat»." },
  { t: "S3-Zugangsdaten erzeugen", d: "Im Object-Storage-Bereich auf «S3-Zugang» / «Access Keys» → «Neuen Schlüssel erstellen». Es erscheinen Access Key und Secret Key – den Secret Key sofort kopieren, er wird nur einmal angezeigt." },
  { t: "Werte hier eintragen", d: "Anbieter «Infomaniak» wählen (Endpoint https://s3.pub1.infomaniak.cloud und Region pub1 werden automatisch gesetzt) → Bucket-Name, Access Key, Secret Key einfügen → «Testen & speichern». Gespeichert wird nur, wenn die Verbindung klappt." },
  { t: "Bestehende Dateien übernehmen", d: "Nach erfolgreichem Test erscheint unten «Migration starten». Dabei werden alle bisherigen Belege und PDFs in deinen Bucket kopiert; der Vorgang kann jederzeit wiederholt werden, bis «fehlend: 0» steht." },
];

export function StorageSetupGuide() {
  const [open, setOpen] = useState(true);
  return (
    <div className="rounded-lg border border-indigo-100 bg-indigo-50/60 p-3" data-testid="storage-setup-guide">
      <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-center justify-between text-left" data-testid="storage-guide-toggle">
        <span className="flex items-center gap-2 text-sm font-medium text-indigo-900">
          <ListChecks className="h-4 w-4" /> So richtest du Infomaniak Object Storage ein (5 Schritte)
        </span>
        {open ? <ChevronUp className="h-4 w-4 text-indigo-700" /> : <ChevronDown className="h-4 w-4 text-indigo-700" />}
      </button>
      {open && (
        <ol className="mt-3 space-y-2">
          {STEPS.map((s, i) => (
            <li key={s.t} className="flex gap-3 text-xs text-indigo-950 leading-relaxed" data-testid={`storage-guide-step-${i + 1}`}>
              <span className="flex-shrink-0 h-5 w-5 rounded-full bg-indigo-600 text-white text-[11px] font-semibold flex items-center justify-center">{i + 1}</span>
              <span><span className="font-semibold">{s.t}.</span> {s.d}</span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
